import React,{useState} from 'react'
import "../../Styles/loginPage.scss"
import HeaderComp from '../HeaderComponent/HeaderComp'
import { ButtonLoadingSpinner } from '../Frontend-library/loadingSpinner/buttonloadingspinner';
import arrowIcon from "../../Assests/icons/Vector.png"
import { useDispatch } from "react-redux";
import { forgotPwd } from '../../redux/reducers/forgotPwdReducer';
import { useNavigate } from 'react-router-dom';
import ResetPasswordSuccess from './ResetPasswordSuccess';
import { rules } from '../../utils/rules';
import { validationMessage } from '../../constants/textConstants';
export default function ResetPasswordForm() {
   const [email, setEmail] = useState(""); 
  const [loading, setLoading] = useState(false); 
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    if (!email) {
      setError(validationMessage.email_req); // Set error if email is empty
      return;
    }else if(!rules.validation.email.test(email)){
      setError(validationMessage.email_invalid); // Set error if invalid email
      return;
    }

    setError("");
    setLoading(true);

    dispatch(forgotPwd({email, dispatch, setIsSuccess, setError}))
      .then(() => setLoading(false)) 
      .catch(() => setLoading(false)); 
  };

  const handleBackButton = ()=>{
    navigate("/signin")
  }
  const handleBlur = () => {
      setError(""); 
  };

  const handleChange = (e) => {
    setEmail(e.target.value);

    if (error) {
      setError(""); // Clear error when typing
    }
  };

  return (
    <>
         <HeaderComp />
         {isSuccess
         ? <ResetPasswordSuccess email={email}/>
         : <div className="loginDiv">
           <div className="formDiv">
             <div className="loginDesc">
             <div className="loginHead">Reset your password</div>
             <div className="loginSubDiv">Forgot your password? Please enter your registered email and we’ll send you a password reset</div>
             </div>
             <form className="auth_container" onSubmit={handleSubmit}>
            <div className="form-group">
             <input
             id="Email"
             placeholder="Email Address"
             type="email"
             name="email"
             className={`tkTextField`}
             value={email}
             onChange={handleChange}
             onBlur={handleBlur}
             />
              <label htmlFor="Email">Email Address</label>
              {error && <span className="error-message">{error}</span>}
            </div>
            <button
              type="submit"
              autoComplete="off"
              className="login_button hover-btn-animation"
              disabled={email===""}
            >
              {loading ? <ButtonLoadingSpinner /> : 'RESET PASSWORD'}
            </button>
          </form>

          <div className='backButtonContainer' onClick={handleBackButton}> 
            <div className='backButton'>
            <div><img src={arrowIcon} alt='arrow'/></div>
            <div className='buttonText'>Back To Login</div>
            </div>
            
          </div>
           </div>
          
         </div>}
       </>
  )
}
